import { render, staticRenderFns } from "./PresetUpdateArea.vue?vue&type=template&id=6cd51ac8&scoped=true&"
import script from "./PresetUpdateArea.vue?vue&type=script&lang=ts&"
export * from "./PresetUpdateArea.vue?vue&type=script&lang=ts&"
import style0 from "./PresetUpdateArea.vue?vue&type=style&index=0&id=6cd51ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd51ac8",
  null
  
)

export default component.exports